export class OneTapsTracking {
  constructor(Vue) {
    this._vue = Vue;
    this._googleEventUuid = null;
    this._reedsyEventUuid = null;

    this._trackReedsySignIn = this._trackReedsySignIn.bind(this);
    this.trackGoogleSignIn = this.trackGoogleSignIn.bind(this);

    window.trackGoogleSignIn = this.trackGoogleSignIn;

    this._initGoogleOneTap();
    this._initReedsyOneTap();
  }

  static addGoogleScript() {
    const scriptTag = document.createElement('script');
    scriptTag.src = 'https://accounts.google.com/gsi/client';
    document.body.appendChild(scriptTag);
  }

  static addTrackingUuidToUrl(url, uuid) {
    return `${url}?tracking_chain_uuid=${uuid}`;
  }

  _initGoogleOneTap() {
    const googleOneTapElement = document.getElementById('g_id_onload');

    if (!googleOneTapElement) {
      return;
    }

    this._googleEventUuid = this._vue.prototype.eventsTracking.storeEvent(
      'social-sign-in-request',
      {
        type: 'one-tap',
        method: 'google',
      },
    );
    const signInUrl = googleOneTapElement.dataset.login_uri;
    googleOneTapElement.dataset.login_uri = OneTapsTracking.addTrackingUuidToUrl(signInUrl, this._googleEventUuid);

    OneTapsTracking.addGoogleScript();
  }

  _initReedsyOneTap() {
    const reedsyOneTapElement = document.getElementById('reedsy-one-tap-trigger');
    if (!reedsyOneTapElement) {
      return;
    }

    this._reedsyEventUuid = this._vue.prototype.eventsTracking.storeEvent(
      'sign-in-request',
      {
        type: 'one-tap',
        method: 'reedsy',
      },
    );
    const signInUrl = reedsyOneTapElement.dataset.link;
    reedsyOneTapElement.dataset.link = OneTapsTracking.addTrackingUuidToUrl(signInUrl, this._reedsyEventUuid);
    reedsyOneTapElement.addEventListener('click', this._trackReedsySignIn);
  }

  _trackReedsySignIn() {
    this._vue.prototype.eventsTracking.sendEvent(this._reedsyEventUuid);
  }

  trackGoogleSignIn(event) {
    // https://developers.google.com/identity/one-tap/web/reference/js-reference#PromptMomentNotification
    if (event.getDismissedReason() === 'credential_returned') {
      this._vue.prototype.eventsTracking.sendEvent(this._googleEventUuid);
    }
  }
}

export default {
  install: function(Vue, options) {
    Vue.prototype.oneTapsTracking = new OneTapsTracking(Vue);
  },
};
